import { BATTLESHIP } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { H5 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import { WORKFLOWS_CONVERSION_REPORTING } from 'automation-ui-canvas/constants/Scopes';
import EnterpriseConversionReportingUpgradePoint from 'automation-ui-canvas/containers/enrollment-conversion/panel/EnterpriseConversionReportingUpgradePoint';
import { useHasScope } from 'automation-ui-core/hooks/authHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledToggleCardWrapper = styled.div.withConfig({
  displayName: "EnrollmentConversionTrackingToggle__StyledToggleCardWrapper",
  componentId: "sc-1laz1yh-0"
})(["display:flex;align-content:center;justify-content:center;margin:44px;"]);
const StyledToggleCard = styled.div.withConfig({
  displayName: "EnrollmentConversionTrackingToggle__StyledToggleCard",
  componentId: "sc-1laz1yh-1"
})(["width:405px;height:190px;gap:24px;"]);
const StyledUIPanelBody = styled(UIPanelBody).withConfig({
  displayName: "EnrollmentConversionTrackingToggle__StyledUIPanelBody",
  componentId: "sc-1laz1yh-2"
})(["top:0;position:sticky;max-height:280px;border-bottom:1px solid ", ";"], BATTLESHIP);
const EnrollmentConversionTrackingToggle = ({
  isReportingEnabled,
  setReportingEnabled,
  loading,
  errorMessage
}) => {
  const trackEvent = useTrackEvent();
  const canViewConversionReporting = useHasScope(WORKFLOWS_CONVERSION_REPORTING);
  const enableMetricsButton = canViewConversionReporting ? /*#__PURE__*/_jsx(UIButton, {
    onClick: () => {
      trackEvent(Trackables.AGGREGATE_PERFORMANCE_TURN_ON_REPORTING);
      setReportingEnabled(!isReportingEnabled);
    },
    disabled: !!errorMessage,
    use: "tertiary-light",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.tracking-toggle.buttonText"
    })
  }) : /*#__PURE__*/_jsx(EnterpriseConversionReportingUpgradePoint, {});
  return /*#__PURE__*/_jsx(StyledUIPanelBody, {
    children: /*#__PURE__*/_jsx(StyledToggleCardWrapper, {
      children: /*#__PURE__*/_jsxs(StyledToggleCard, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.tracking-toggle.title"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.tracking-toggle.content"
          })
        }), loading ? /*#__PURE__*/_jsx(UIPanelSection, {
          children: /*#__PURE__*/_jsx(UILoadingSpinner, {
            grow: true
          })
        }) : /*#__PURE__*/_jsx(UIFormControl, {
          error: !!errorMessage,
          validationMessage: errorMessage,
          children: enableMetricsButton
        })]
      })
    })
  });
};
export default EnrollmentConversionTrackingToggle;